import Service from "../../services";
import { checkAndReturn } from "../../main";

const state = {};

const getters = {};

const actions = {
  index({ commit }, params) {
    return Service.Consider.index(params.payload).then((res) => {
      return checkAndReturn(params, res);
    });
  },
  save({ commit }, params) {
    return Service.Consider.save(params.payload).then((res) => {
      return checkAndReturn(params, res);
    });
  },
  update({ commit }, params) {
    return Service.Consider.update(params.payload).then((res) => {
      return checkAndReturn(params, res);
    });
  },
  create({ commit }, params) {
    return Service.Consider.create(params.payload).then((res) => {
      return checkAndReturn(params, res);
    });
  },
  edit({ commit }, params) {
    return Service.Consider.edit(params.payload).then((res) => {
      return checkAndReturn(params, res);
    });
  },
  getEvaluateForm({ commit }, params) {
    return Service.Consider.getEvaluateForm(params.payload).then((res) => {
      return checkAndReturn(params, res);
    });
  },
  saveEvaluateForm({ commit }, params) {
    return Service.Consider.saveEvaluateForm(params.payload).then((res) => {
      return checkAndReturn(params, res);
    });
  },
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
